import {ApiService, ErrorExtract} from './ApiService';
import {isEmpty, isObject} from 'lodash';

export const CrudService = {
    _get,
    _post,
    _put,
    _delete
};

function _get(options = {}, dispatch) {
    return _execute({
        url: options.url,
        method: 'get',
        params: options.params,
        consts: options.consts || {},
        props: isObject(options.props) ? options.props : {}
    }, dispatch);
}

function _post(options = {}) {
    return _execute({
        url: options.url,
        method: 'post',
        data: options.data,
        props: isObject(options.props) ? options.props : {}
    });
}

function _put(options = {}) {
    return _execute({
        url: options.url,
        method: 'put',
        data: options.data,
        props: isObject(options.props) ? options.props : {}
    });
}

function _delete(options = {}) {
    return _execute({
        url: options.url,
        method: 'delete',
        data: options.data,
        props: isObject(options.props) ? options.props : {}
    });
}

function _execute(options, dispatch) {
    const consts = options.consts || {};

    return new Promise(function (resolve, reject) {

        if (!isEmpty(consts.start)) {
            dispatch && dispatch({
                type: consts.start,
                props: options.props,
            });
        }

        ApiService(options)
            .then(({data}) => {

                if (consts.success) {
                    dispatch && dispatch({
                        type: consts.success,
                        payload: data,
                        props: options.props,
                    });
                }
                resolve(data);
            }).catch(error => {
            let payload = ErrorExtract(error);
            if (consts.failure) {
                dispatch && dispatch({
                    type: consts.failure,
                    error: 'open',
                    props: options.props,
                    payload
                });
            }
            reject(payload);
        });
    });
}
